import { v4 as uuid } from 'uuid';

export interface EventBusInterface {
    subscriptions: Record<string, Record<string, <T>(params: T) => void>>;
    dispatch: <Params>(subscription: string, params: Params) => void;
    subscribe: <Params>(subscription: string, subscriber: (params: Params) => void) => string;
    unsubscribe: (subscription: string, subscriberId: string) => void;
    getSubscriptions: () => string[];
}

export default class EventBus implements EventBusInterface {
    static instance: EventBus;

    static getInstance() {
        if (!EventBus.instance) {
            EventBus.instance = new EventBus();
        }

        return EventBus.instance;
    }

    public subscriptions: Record<string, Record<string, <T>(params: T) => void>>;

    constructor() {
        this.subscriptions = {};
    }

    public dispatch<Params>(subscription: string, params: Params) {
        if (!this.subscriptions[subscription]) {
            return;
        }

        Object.keys(this.subscriptions[subscription]).forEach((eventId) => {
            this.subscriptions[subscription][eventId]<Params>(params);
        });
    }

    public subscribe<Params>(subscription: string, subscriber: (params: Params) => void) {
        const subscriberId = uuid();

        if (!(subscription in this.subscriptions)) {
            this.subscriptions[subscription] = {};
        }

        Object.assign(this.subscriptions[subscription], {
            [subscriberId]: subscriber,
        });

        return subscriberId;
    }

    public unsubscribe(subscription: string, subscriberId: string) {
        if (!this.subscriptions[subscription]) {
            // eslint-disable-next-line no-console
            console.warn(`You cant unsubscribe if there are no subscriptions for: ${subscription}`);
            return;
        }

        if (!this.subscriptions[subscription][subscriberId]) {
            // eslint-disable-next-line no-console
            console.warn(`You cannot unsubscribe a subscriber (${subscriberId}) that is not subscribed to: ${subscription}`);
            return;
        }

        delete this.subscriptions[subscription][subscriberId];
    }

    public getSubscriptions() {
        return Object.keys(this.subscriptions);
    }
}
